const EMPTY_PLACEHOLDER = 'Start typing...';
const TITLE_PLACEHOLDER = 'Add title...';
const DESCRIPTION_PLACEHOLDER = 'Add description...';
const LABEL_PLACEHOLDER = 'Add label...';

const TITLE_SLOTS = new Set(['title', 'section_title', 'headline', 'heading']);
const DESCRIPTION_SLOTS = new Set([
  'summary',
  'excerpt',
  'description',
  'body',
  'section_description',
  'bio',
]);
const LABEL_SLOTS = new Set(['section_tag', 'eyebrow']);

export function placeholderForSlot(slot: unknown): string {
  if (typeof slot !== 'string') return EMPTY_PLACEHOLDER;
  if (TITLE_SLOTS.has(slot)) return TITLE_PLACEHOLDER;
  if (DESCRIPTION_SLOTS.has(slot)) return DESCRIPTION_PLACEHOLDER;
  if (LABEL_SLOTS.has(slot)) return LABEL_PLACEHOLDER;
  return EMPTY_PLACEHOLDER;
}
